// Need to be refactored
import React from 'react'
import _uniq from 'lodash/uniq'

export default class FilterItemsField extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      promotionLinkCopied: false,
    }
    this.pending = ''
  }
  componentDidMount() {
    const { focusOnStart } = this.props
    if (focusOnStart) {
      this.refs.tag.focus()
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value) {
      this.setState(() => ({ value: newProps.value }))
    }
    this.pending = ''
  }

  onFilterItemsChange = (tags, changed, changedIndexes) => {
    const { controlOutside, onChange, flagFilterUniq = false } = this.props
    let updatedTags = tags.map(promo => promo.replace(' ', '')).filter(tag => tag)
    this.pending = ''

    if (flagFilterUniq) {
      updatedTags = _uniq(updatedTags)
    }

    if (!controlOutside) {
      this.setState({
        value: updatedTags,
      })
    }
    if (onChange) {
      onChange(updatedTags, changed, changedIndexes)
    }
  }

  handleRemoveItem = (index) => {
    const { value } = this.state;
    const newValue = [...value];
    newValue.splice(index, 1);
    
    // When removing an item, we need to call onChange with the new array,
    // the removed item (which is null since we're removing), and the index
    const { onChange } = this.props;
    
    if (onChange) {
      // This format matches what the parent Filters component expects
      onChange(newValue, null, [index]);
    } else {
      this.setState({ value: newValue });
    }
  }

  render() {
    const { value } = this.state
    const {
      filterItemsContainerClassName = '',
    } = this.props

    return (
      <div className={`filter-items-field ${filterItemsContainerClassName}`}>
        {value.map((item, index) => (
          <div className="filter-item" key={index}>
            <div className={`filter-item-content`}>
              <div className="filter-item-remove" onClick={() => this.handleRemoveItem(index)}>
                <i className="fa fa-times"></i>
              </div>
              <div className="filter-item-label">
                <div className="filter-item-label-text">
                  {index !== 0 && !item.isAnd && (
                    <span className="filter-and-or">
                      OR
                    </span>
                  )}
                  {index !== 0 && item.isAnd && (
                    <span className="filter-and-or">
                      AND
                    </span>
                  )}
                  {item.isNot && (
                    <span className="filter-not">
                      IS NOT
                    </span>
                  )}
                  {item.label}
                </div>
              </div>
              <div className="filter-item-value">
                {item.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}
